import axios from 'axios';
import { from } from 'rxjs';

export const getLabelQueBatchesRaw = (userId, fromProcessDate, pageSize, page = 1) => {
  const formOfRequest = {
    userId,
    archived: false,
    labelQueue: false,
    page,
    pageSize,
    fromProcessDate,
  };
  if (!formOfRequest.fromProcessDate) {
    delete formOfRequest.fromProcessDate;
  }
  return axios.get('label/batch/labelBatches', { params: formOfRequest });
};

// TODO: Open user made batches (and single label generated batches) only show when labelQueue: false
export const getLabelQueBatches = (userId, fromProcessDate, pageSize, page = 1) => {
  const getBatches$ = from(
    getLabelQueBatchesRaw(userId, fromProcessDate, pageSize, page).then((response) => {
      return response.data.results;
    }),
  );
  return getBatches$;
};

export const getLabelQueBatchWarningAndError = (batchId) => {
  const getAndTransform = axios.get(`label/batch/labelBatchStatus?batchId=${batchId}`).then((response) => {
    return response;
  });

  const getWarningError$ = from(getAndTransform);
  return getWarningError$;
};

export const retryBatch = (batchId) => {
  const postRequest = axios
    .post('label/batch/retryFailedItems', {
      labelBatchId: parseInt(batchId, 10),
    })
    .then((response) => {
      return response;
    });

  const postRequest$ = from(postRequest);
  return postRequest$;
};
